import {IStorageDriver} from '@src/@interfaces/services/Storage/IStorageDriver';
import {StringArray} from '@src/@interfaces/types';

export default class TemporaryStorage implements IStorageDriver {
    protected items: StringArray<string> = {};

    get length(): number {
        return Object.keys(this.items).length;
    }

    clear(): void {
        this.items = {};
    }

    getItem(key: string): string | null {
        return this.items[key] ?? null;
    }

    key(index: number): string | null {
        return Object.keys(this.items).at(index) ?? null;
    }

    removeItem(key: string): void {
        if (key in this.items) {
            delete this.items[key];
        }
    }

    setItem(key: string, value: string): void {
        this.items[key] = value;
    }
}
